const toggles = document.querySelectorAll('[data-comment-form-toggle]');

const prefersReducedMotion = () => document.documentElement.dataset.reducedMotion === 'true';

const setExpanded = (button, panel, expanded, focusForm = false) => {
  button.setAttribute('aria-expanded', String(expanded));
  button.classList.toggle('is-active', expanded);
  panel.hidden = !expanded;

  if (!expanded) {
    return;
  }

  window.requestAnimationFrame(() => {
    panel.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'center',
    });

    if (focusForm) {
      panel.querySelector('textarea')?.focus({ preventScroll: true });
    }
  });
};

toggles.forEach((button) => {
  const panelId = button.getAttribute('aria-controls');
  const panel = panelId ? document.getElementById(panelId) : null;

  if (!panel) {
    button.hidden = true;
    return;
  }

  const shouldStartExpanded = window.location.hash === '#respond';
  setExpanded(button, panel, shouldStartExpanded);

  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    setExpanded(button, panel, expanded, expanded);

    window.dispatchEvent(new CustomEvent('abdelmeged:interaction', {
      detail: { type: 'comment' },
    }));
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('.comment-reply-link')) {
      setExpanded(button, panel, true);
    }
  });
});
